/* eslint-disable @typescript-eslint/no-explicit-any */

function getCookie(name: string) {
  const value = `; ${document.cookie}`;
  const parts = value.split(`; ${name}=`);
  if (parts !== undefined && parts.length === 2) {
    const newLocal = parts.pop();
    return newLocal?.split(';').shift();
  }
}

export default class RestUtilities {
  static get(url: string) {
    return RestUtilities.request('GET', url);
  }

  static delete(url: string) {
    return RestUtilities.request('DELETE', url);
  }

  static put(url: string, data: any) {
    return RestUtilities.request('PUT', url, data);
  }

  static post(url: string, data: any) {
    return RestUtilities.request('POST', url, data, undefined);
  }

  static postFormData(url: string, data: any) {
    return RestUtilities.request('POST', url, data, true);
  }

  static request(
    method: string,
    url: string,
    data?: any,
    isFormData?: boolean
  ) {
    let ok = false;
    let body = data;
    const token = getCookie('token');

    let statusCode = 200;
    let statusText = '';
    const headers = new Headers();
    headers.set('Accept', 'application/json');
    if (token) headers.set('Authorization', `Bearer ${token}`);

    if (!isFormData) {
      headers.set('Content-Type', 'application/json');
      body = JSON.stringify(data);
    } else {
      //headers.set('Content-Type','multipart/form-data');
      body = data;
    }

    return fetch(url, { method, headers, body })
      .then((response) => {
        ok = response.ok;
        statusCode = response.status;
        statusText = response.statusText;
        if (statusCode === 401) {
          window.location.href = '/login';
          return;
        }
        const responseContentType = response.headers.get('content-type');
        if (
          responseContentType &&
          responseContentType.indexOf('application/json') !== -1
        ) {
          return response.json();
        }
        return response.text();
      })
      .then((responseContent) => {
        const response = {
          ok: ok,
          hasModelErrors: statusCode === 400,
          content: ok ? responseContent : null,
          errorContent: ok ? null : responseContent,
          status: statusCode,
          statusText: statusText,
        };
        return response;
      });
  }
}
